'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
import { PRESET_TYPES, getDateRangePresetForString } from '../../lib/AdsSimpleDateRange';
import { AttributionViews } from '../../lib/Constants';
import AdAccountIdentityRecord from '../ad-accounts/AdAccountIdentityRecord.js';
const SequenceListFilterRecord = Record({
  timeRange: getDateRangePresetForString(PRESET_TYPES.LAST_THIRTY_DAYS),
  adAccounts: ImmutableSet(),
  attributionView: AttributionViews.FIRST_FORM_SUBMISSION
});
export const fromGlobalFilters = ({
  timeRange,
  adAccounts,
  attributionView
}) => SequenceListFilterRecord({
  timeRange,
  attributionView,
  adAccounts: adAccounts.map(({
    accountId,
    network
  }) => AdAccountIdentityRecord({
    accountId,
    network
  }))
});
export default SequenceListFilterRecord;